import { render, staticRenderFns } from "./FloorEdit.vue?vue&type=template&id=b983675e&scoped=true"
import script from "./FloorEdit.vue?vue&type=script&lang=js"
export * from "./FloorEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b983675e",
  null
  
)

export default component.exports